module.exports = __webpack_public_path__ + "img/promo4.c235c04f.jpg";